import mock from '@/@fake-db/mock'
/* eslint-disable global-require */
const data = {
  pricing: {
    basicPlan: {
      title: 'Basic',
      img: require('@/assets/images/illustration/Pot1.svg'),
      subtitle: 'A simple start for everyone',
      monthlyPrice: 0,
      yearlyPlan: {
        perMonth: 0,
        totalAnual: 0,
      },
      planBenefits: [
        'Le lorem ipsum imprimerie',
        'Le lorem ipsum est, imprimerie',
        'Le lorem ipsum est, en imprimerie',
        'Le lorem ipsum une suite de mots',
        'Le lorem ipsum est, en imprimerie',
      ],
      popular: false,
    },
    standardPlan: {
      title: 'Standard',
      img: require('@/assets/images/illustration/Pot2.svg'),
      subtitle: 'For small to medium businesses',
      monthlyPrice: 199,
      yearlyPlan: {
        perMonth: 150,
        totalAnual: 1800,
      },
      planBenefits: [
        'Le lorem ipsum imprimerie',
        'Le lorem ipsum est, imprimerie',
        'Le lorem ipsum est, en imprimerie',
        'Le lorem ipsum une suite de mots',
        'Le lorem ipsum est, en imprimerie',
      ],
      popular: true,
    },
    enterprisePlan: {
      title: 'Enterprise',
      img: require('@/assets/images/illustration/Pot3.svg'),
      subtitle: 'Solution for big organizations',
      monthlyPrice: 299,
      yearlyPlan: {
        perMonth: 250,
        totalAnual: 3000,
      },
      planBenefits: [
        'Le lorem ipsum imprimerie',
        'Le lorem ipsum est, imprimerie',
        'Le lorem ipsum est, en imprimerie',
        'Le lorem ipsum une suite de mots',
        'Le lorem ipsum est, en imprimerie',
      ],
      popular: false,
    },
    qandA: [
      {
        question: 'Does my subscription automatically renew?',
        ans:
          'Le lorem ipsum est, en imprimerie, une suite de mots sans signification utilisée à titre provisoire pour calibrer une mise en page, le texte définitif venant remplacer le faux-texte dès qu il est prêt ou que la mise en page est achevée.',
      },
      {
        question: 'puis-je stocker l élément sur un intranet pour que tout le monde y ait accès?',
        ans:
          'Le lorem ipsum est, en imprimerie, une suite de mots sans signification utilisée à titre provisoire pour calibrer une mise en page, le texte définitif venant remplacer le faux-texte dès qu il est prêt ou que la mise en page est achevée.',
      },
      {
        question: 'Suis-je autorisé à modifier l\'email que j\'ai acheté?',
        ans:
          'Le lorem ipsum est, en imprimerie, une suite de mots sans signification utilisée à titre provisoire pour calibrer une mise en page, le texte définitif venant remplacer le faux-texte dès qu il est prêt ou que la mise en page est achevée.',
      },
    ],
  },
}
/* eslint-disable global-require */
mock.onGet('/pricing/data').reply(() => [200, data.pricing])
